import { render, staticRenderFns } from "./OverviewCampaign.vue?vue&type=template&id=17f5d1ca"
import script from "./OverviewCampaign.vue?vue&type=script&lang=js"
export * from "./OverviewCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports